<template>
  <div class="as-slider">
    <div class="owl-item">
      <img src="../assets/images/slider/mainSlide-5.jpg" />
    </div>
    <div class="owl-item">
      <img src="../assets/images/slider/mainSlide-1.jpg" />
    </div>
    <div class="owl-item">
      <img src="../assets/images/slider/mainSlide-2.jpg" />
    </div>
    <div class="owl-item">
      <img src="../assets/images/slider/mainSlide-4.jpg" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.as-slider {
  position: relative;
  z-index: -1;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.as-slider .owl-item > div {
  width: 100%;
  height: 100vh;
  background-size: cover;
}
.as-slider .owl-item.active {
  z-index: 100;
}
.as-slider .owl-item {
  position: absolute;
  width: 100%;
  height: 100%;
  background: no-repeat 50% 50%;
  background-size: cover;
  animation-name: kenburns;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 40s;
  opacity: 1;
  transform: scale(1.5);
}
.as-slider .owl-item img {
  height: 100vh;
  object-fit: cover;
}
.as-slider .owl-item:nth-child(1) {
  animation-name: kenburns-1;
  z-index: 3;
}
.as-slider .owl-item:nth-child(2) {
  animation-name: kenburns-2;
  z-index: 2;
}
.as-slider .owl-item:nth-child(3) {
  animation-name: kenburns-3;
  z-index: 1;
}
.as-slider .owl-item:nth-child(4) {
  animation-name: kenburns-4;
  z-index: 0;
}
@keyframes kenburns-1 {
  0% {
    opacity: 1;
    transform: scale(1.2);
  }
  1.5625% {
    opacity: 1;
  }
  23.4375% {
    opacity: 1;
  }
  26.5625% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.2);
  }
  98.4375% {
    opacity: 0;
    transform: scale(1.21176);
  }
  100% {
    opacity: 1;
  }
}
@keyframes kenburns-2 {
  23.4375% {
    opacity: 1;
    transform: scale(1.2);
  }
  26.5625% {
    opacity: 1;
  }
  48.4375% {
    opacity: 1;
  }
  51.5625% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.2);
  }
}
@keyframes kenburns-3 {
  48.4375% {
    opacity: 1;
    transform: scale(1.2);
  }
  51.5625% {
    opacity: 1;
  }
  73.4375% {
    opacity: 1;
  }
  76.5625% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.2);
  }
}
@keyframes kenburns-4 {
  73.4375% {
    opacity: 1;
    transform: scale(1.2);
  }
  76.5625% {
    opacity: 1;
  }
  98.4375% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
</style>
